module.exports = __webpack_public_path__ + "media/featured/RealSimple-8165558f.png";